import {WhitelistService} from "@/service/whitelist";

const state = {};

const getters = {};

const actions = {
    async getAuthWhitelist() {
        try {
            const response = await WhitelistService.getAuthWhitelist();
            return response.data;
        } catch (error) {
            return { entries: [] };
        }
    },

    addAuthWhitelist(ctx, { ip_address, mask }) {
        return WhitelistService.addAuthWhitelist(ip_address, mask);
    },

    deleteAuthWhitelist(ctx, entry_id) {
        return WhitelistService.deleteAuthWhitelist(entry_id);
    },

    async getApiKeyWhitelist() {
        try {
            const response = await WhitelistService.getApiKeyWhitelist();
            return response.data;
        } catch (error) {
            return { entries: [] };
        }
    },

    addApiKeyWhitelist(ctx, { ip_address, mask }) {
        return WhitelistService.addApiKeyWhitelist(ip_address, mask);
    },

    deleteApiKeyWhitelist(ctx, entry_id) {
        return WhitelistService.deleteApiKeyWhitelist(entry_id);
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
